// import { generator, notFoundRouter } from '@/utils/permissions';
import { get } from '@/utils/request';
import { login, getUserInfoById, getNav } from '@/api/user';
import { createSessionExpiredError } from '@/utils/session';

const currentToken = (state) => state.token || window.localStorage.getItem('token') || '';
let sessionCheck;

function clearSession(commit, state) {
  clearInterval(state.refresh);
  commit('SET_REFRESH', null);
  commit('NEXT_SESSION');
  commit('SET_TOKEN', '');
  window.localStorage.setItem('token', '');
  commit('SET_USERINFO', {});
  commit('SET_NAV', []);
  commit('SET_LOGINSTATE', { state: 'PASSWORD', phone: '', pwd: '' });
}

const user = {
  namespaced: true,
  state: {
    userInfo: {},
    token: '',
    sessionTimeout: false,
    sessionVersion: 0,
    refresh: null,
    lastUpdateTime: 0,
    loginFlag: false,
    loginState: 'PASSWORD',
    phone: '',
    pwd: '',
    nav: [],
  },
  mutations: {
    NEXT_SESSION: (state) => {
      state.sessionVersion++;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_LOGINFLAG: (state, flag) => {
      state.loginFlag = flag;
    },
    SET_LOGINSTATE: (state, payload) => {
      state.loginState = payload.state;
      state.phone = payload.phone;
      state.pwd = payload.pwd;
    },
    SET_SESSIONTIMEOUT: (state, sessionTimeout) => {
      state.sessionTimeout = sessionTimeout;
    },
    SET_REFRESH: (state, refresh) => {
      state.refresh = refresh;
    },
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo;
    },
    SET_NAV: (state, nav) => {
      state.nav = nav;
    },
  },
  getters: {
    getToken(state) {
      return state.token || window.localStorage.getItem('token');
    },
  },
  actions: {
    setToken({ commit, state }, token) {
      clearInterval(state.refresh);
      commit('SET_REFRESH', null);
      commit('NEXT_SESSION');
      commit('SET_TOKEN', token);
      commit('SET_USERINFO', {});
      commit('SET_NAV', []);
      window.localStorage.setItem('token', token);
      if (token) commit('SET_SESSIONTIMEOUT', false);
    },
    async login({ commit, dispatch }, params) {
      try {
        let data = await login(params);
        const { token, expire, sms_token } = data;
        if (sms_token) {
          const tokens = localStorage.getItem('LOGINSMSTOKEN');
          if (tokens) {
            if (
              tokens.split(',').findIndex((v) => {
                return v == sms_token;
              }) == -1
            ) {
              localStorage.setItem('LOGINSMSTOKEN', tokens + ',' + sms_token);
            }
          } else {
            localStorage.setItem('LOGINSMSTOKEN', sms_token);
          }
        }
        await dispatch('setToken', token);
        commit('SET_LOGINFLAG', false);
        const userInfo = await dispatch('getUserInfoAction');
        return userInfo;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getUserInfoAction({ commit, dispatch, state }) {
      const version = state.sessionVersion;
      const userInfo = await getUserInfoById();
      if (version !== state.sessionVersion || !currentToken(state)) {
        throw createSessionExpiredError('登录状态已变化');
      }
      const nav = await getNav();
      if (version !== state.sessionVersion || !currentToken(state)) {
        throw createSessionExpiredError('登录状态已变化');
      }
      commit('SET_USERINFO', userInfo);
      commit('SET_NAV', nav);
      dispatch('setRefresh');
      return userInfo;
    },
    checkSession({ state }) {
      const token = currentToken(state);
      const version = state.sessionVersion;
      if (!token) return Promise.reject(createSessionExpiredError());
      if (sessionCheck && sessionCheck.version === version) return sessionCheck.pending;
      const check = { version };
      check.pending = getUserInfoById().then(() => {
        if (state.sessionVersion !== version || !currentToken(state)) {
          throw createSessionExpiredError('登录状态已变化');
        }
        return true;
      }).finally(() => {
        if (sessionCheck === check) sessionCheck = null;
      });
      sessionCheck = check;
      return check.pending;
    },
    sessionExpired({ commit, state }, { token } = {}) {
      if (!token || currentToken(state) !== token) return false;
      clearSession(commit, state);
      commit('SET_SESSIONTIMEOUT', true);
      return true;
    },
    async setRefresh({ commit, state }) {
      if (state.refresh) {
        clearInterval(state.refresh);
      }
      let refresh = setInterval(() => {
        const token = currentToken(state);
        const version = state.sessionVersion;
        if (!token) return;
        get('/api/v1/refresh', {})
          .then((e) => {
            if (token !== currentToken(state) || version !== state.sessionVersion) return;
            // Renewal belongs to the same login; do not invalidate pending reads.
            commit('SET_TOKEN', e.token);
            window.localStorage.setItem('token', e.token);
          })
          .catch(() => {
            // The request layer handles 401. Temporary failures retain the session.
          });
      }, 60000 * 5);
      commit('SET_REFRESH', refresh);
    },
    // 登出
    async logout({ commit, state }) {
      const version = state.sessionVersion;
      try {
        await get('/api/v1/logout');
      } catch (error) {
        // An expired session or unavailable server must not prevent local logout.
      } finally {
        if (version === state.sessionVersion) {
          clearSession(commit, state);
          commit('SET_SESSIONTIMEOUT', false);
          commit('SET_LOGINFLAG', false);
        }
      }
    },
  },
};

export default user;
